<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="allTripsObj.isActive?'tag is-success':'tag'">Standard</span> 
                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">All trips</p>
                        <p>Trigger for any trip  </p>
                    </div>
                    <div class="allbtns">
                        <b-switch 
                            :rounded="true" 
                            :value="allTripsObj.isActive" 
                            v-model="allTripsObj.isActive"
                            @input="allTrips" 
                            
                            >
                        </b-switch>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
import { all } from 'q';

export default{
    name:"",
    props: {
    value: {
      type: [Object],
    },
  },
    data(){
        return{
            allTripsObj:this.value?this.value:{
                    name: "allTrips",
                    isActive: false,
                    type:'all',
                    message:''
          }
        }
    },
    methods:{
        allTrips(){

            this.$emit('allTrips',this.allTripsObj)
        }
    },
    mounted(){
        this.allTripsObj.type='all';
        this.allTripsObj.message=this.buildMessage;
        this.$emit('allTrips',this.allTripsObj)

    },
    computed:{
        buildMessage(){

            var string ='Trigger for any trip';

            return string;
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.allTripsObj = this.value;
        this.allTripsObj.type='all';
        this.allTripsObj.message=this.buildMessage;
        this.$emit('allTrips',this.allTripsObj)

      },
      deep: true,
    },
  },
}
</script>